import { render, staticRenderFns } from "./delnotassignedShipments.vue?vue&type=template&id=b4c8e7a4&"
import script from "./delnotassignedShipments.vue?vue&type=script&lang=js&"
export * from "./delnotassignedShipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports